import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const savedLanguage = localStorage.getItem("selectedLanguage");

export const initI18n = (apiUrl, defaultLang) =>
    i18n
        .use(HttpApi)
        .use(initReactI18next)
        .init({
            fallbackLng: "sr_rs",
            debug: false,
            backend: {
                loadPath: `${apiUrl}translations/static/pages/{{lng}}`,
                // Add custom headers
                requestOptions: {
                    headers: {
                        "X-App-Type": "web",
                        "X-App-Version": process.env.REACT_APP_VERSION ?? "localhost"
                    },
                },
            },
            lng: savedLanguage || defaultLang || "sr_rs",
            react: {
                useSuspense: false,
            },
        });

export default i18n;
